import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-sampling-plus': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3zM355.4 258.3l58.4-0.3v23.2h-50.5l-18 43.4c-4.6 11-20.9 8.7-22.3-3.1l-2.7-22.3-6.8 83c-1.1 14.1-22 14.2-23.1-0.1l-4.9-64.4-4.6 58.6c-1.1 14.3-22.3 14.1-23.2-0.2l-4.5-71.8-4.9 80.5c-0.9 14.5-22.3 14.5-23.2 0.1l-4.8-73.3-4.6 70.4c-0.9 14.3-22.1 14.5-23.2 0.1l-5.7-78.3-3.8 43.6c-1.2 13.7-21.1 14.2-23.1 0.7l-10.7-73.1c-2 3.9-6 6.4-10.4 6.4h-51.3v-23.2h43.9l13.2-27.7c4.9-10.3 20.3-8.1 22 3.3l1.8 12.2 7.7-89.8c1.2-14.1 22.1-14.1 23.2 0.2l4.1 57 5.3-80.2c1-14.4 22.3-14.4 23.2 0l4.3 66.3 5.1-83.7c0.9-14.4 22.3-14.5 23.2 0l5.9 94.3 3.5-44.9c1.1-14.2 22.1-14.3 23.2 0l5.2 68.8 4.3-51.4c1.1-13.8 21.4-14.3 23.1-0.4l11 92.8 4-9.5c1.7-4.4 6-7.2 10.7-7.2zM277.4 263.5c4.1 0 7.5-3.4 7.5-7.5 0-4.2-3.4-7.5-7.5-7.5h-21.9v-21.9c0-4.2-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5v21.9h-21.9c-4.1 0-7.5 3.4-7.5 7.5 0 4.2 3.4 7.5 7.5 7.5h21.9v21.9c0 4.2 3.4 7.5 7.5 7.5 4.2 0 7.5-3.4 7.5-7.5v-21.9h21.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-sampling-plus.js
// module id = 775
// module chunks = 0